import Vue from 'vue';
import App from './App.vue';
import {router} from './router.js';
import 'bootstrap';

import 'bootstrap/dist/css/bootstrap.min.css';

require('@/assets/style.css');

Vue.filter('pronom', function(value) {
  return value === 'female' ? 'Mme' : 'Mr';
});

new Vue({
  name: 'Arno',
  router,
  render: h => h(App),
}).$mount('#app');
